class MiniCart extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.header = document.querySelector('sticky-header');
    this.drawer = document.querySelector('cart-drawer');
    this.contentsLoaded = false;

    // The drawer sits off-canvas at translateX(100%) until it is opened, so an
    // IntersectionObserver on this element never fires until AFTER the shopper
    // clicks the cart. That produced a loading spinner on every first open.
    //
    // Instead: prefetch the drawer markup once the browser is idle, and also on
    // first hover/focus of the cart trigger. The IntersectionObserver is kept as
    // a safety net for any path that skips both.
    const prefetch = () => this.loadContents();

    if ('requestIdleCallback' in window) {
      requestIdleCallback(prefetch, { timeout: 3000 });
    } else {
      setTimeout(prefetch, 1200);
    }

    const trigger = this.drawer && this.drawer.querySelector('summary');
    if (trigger) {
      ['pointerenter', 'focusin', 'touchstart'].forEach(evt =>
        trigger.addEventListener(evt, prefetch, { once: true, passive: true })
      );
    }

    new IntersectionObserver(this.handleIntersection.bind(this)).observe(this);
  }

  handleIntersection(entries, observer) {
    if (!entries[0].isIntersecting) return;
    observer.unobserve(this);
    this.loadContents();
  }

  loadContents() {
    if (this.contentsLoaded || this.contentsLoading) return Promise.resolve();
    this.contentsLoading = true;

    return fetch(this.dataset.url)
      .then(response => {
        if (!response.ok) throw new Error('mini-cart section ' + response.status);
        return response.text();
      })
      .then(html => {
        const target = document.getElementById('mini-cart');
        if (!target) return;
        target.innerHTML = this.getSectionInnerHTML(html, '.shopify-section');
        this.contentsLoaded = true;
        document.dispatchEvent(new CustomEvent('cartdrawer:opened'));
      })
      .catch(e => {
        console.error('[cart-drawer]', e);
      })
      .finally(() => {
        this.contentsLoading = false;
      });
  }

  open() {
    const detailsElement = this.drawer.querySelector('details');
    if (detailsElement.hasAttribute('open')) {
      return;
    }
    
    this.drawer.openMenuDrawer();
  }

  renderContents(parsedState) {
    this.productId = parsedState.id;
    this.contentsLoaded = true;
    this.getSectionsToRender().forEach((section => {
      if (document.getElementById(section.id)) {
        document.getElementById(section.id).innerHTML =
          this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
      }
    }));

    this.open();
  }

  getSectionsToRender() {
    return [
      {
        id: 'mini-cart',
        section: 'mini-cart',
        selector: '.shopify-section'
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      },
      {
        id: 'mobile-cart-icon-bubble',
        section: 'mobile-cart-icon-bubble',
        selector: '.shopify-section'
      }
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }
}

customElements.define('mini-cart', MiniCart);
